"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const Select_1 = __importDefault(require("../Select/Select"));
const styled_1 = __importDefault(require("../utils/styled"));
const StyledSelect = styled_1.default(Select_1.default) `
  margin: ${({ theme }) => -theme.space.medium}px ${({ theme }) => -theme.space.content}px;
  height: 100%;
  min-height: 0;
  border: 0;
  font-weight: ${({ theme }) => theme.font.weight.regular};
  width: calc(100% + ${({ theme }) => theme.space.content * 2}px); /* 2 for left _and_ right. */
  border-radius: 0;

  [role="listbox"] > div:nth-of-type(2) {
    box-shadow: 0 4px 9px 2px rgba(0, 0, 0, 0.3);
  }

  input {
    border: 0;
  }

  [role="button"] {
    border-left: 0;
  }
`;
exports.DataTableSelect = props => React.createElement(StyledSelect, Object.assign({ fullWidth: true }, props));
exports.default = exports.DataTableSelect;
//# sourceMappingURL=DataTableSelect.js.map